import ProductList from './components/ProductList';

const ProductListPage = () => {
  return (
    <div>
      <ProductList />
    </div>
  );
};

export default ProductListPage;
